// 通知发布
<template>
  <div>
      fabu
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>